/**
 * DO NOT EDIT THIS FILE
 */

import React from 'react';

import logo from './images/clinique_logo.svg';
import bag from './images/bag.svg';
import search from './images/search.svg';
import caret from './images/caret.svg';
import burger from './images/burger.svg';

import './styles/menu.scss';

export const Menu = () =>
  <nav className="elc-nav">
    <div className="elc-nav__branding">
      <div className="elc-nav__logo"><img alt="Clinique" src={logo} /></div>
    </div>
    <div className="elc-nav__text-links">
      <div className="elc-nav__text">New</div>
      <div className="elc-nav__text">clinique iD&trade;</div>
      <div className="elc-nav__text">Best Sellers</div>
      <div className="elc-nav__text">Shop All <span className="elc-nav__text-more"><img src={caret} alt="see more" /></span></div>
    </div>
    <div className="elc-nav__utility">
      <div className="elc-nav__icon elc-nav__icon--bag"><img alt="Shopping Bag" src={bag}  /></div>
      <div className="elc-nav__icon elc-nav__icon--search"><img alt="Search" src={search} /></div>
      <div className="elc-nav__icon elc-nav__icon--burger"><img alt="Menu" src={burger} /></div>
    </div>
  </nav>
